import { createVisitorIdentification } from '../api/hubspot'
import { setHubSpotConversationSettings } from '../utils/crm'

export const createHubSpotVisitorIdentification = (employee = {}): Function => {
  return () => {
    const { email, firstName, lastName } = employee
    return createVisitorIdentification(email, firstName, lastName).then((response) => {
      const token = response && response.token
      setHubSpotConversationSettings(false, email, token)

      return response
    })
  }
}



// WEBPACK FOOTER //
// ./src/actions/hubspot.js